function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 8,
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.9766 0H7.97656C3.55828 0 -0.0234375 3.58172 -0.0234375 8V40C-0.0234375 44.4183 3.55829 48 7.97656 48H39.9766C44.3948 48 47.9766 44.4183 47.9766 40V8C47.9766 3.58172 44.3948 0 39.9766 0Z",
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0817 32.0323C21.2238 30.89 21.2237 29.0381 20.0815 27.8959L18.015 25.8294C18.014 25.8284 18.0124 25.8284 18.0114 25.8294L18.0108 25.83C18.0101 25.8307 18.0091 25.8307 18.0084 25.83C18.0077 25.8293 18.0067 25.8293 18.006 25.83L-0.9318 44.7678C-2.07399 45.91 -2.07385 47.7619 -0.9315 48.9039C0.210618 50.0457 2.06205 50.0456 3.204 48.9036L15.9506 36.157C15.9516 36.156 15.9531 36.1565 15.9534 36.1578C15.9537 36.1591 15.9552 36.1596 15.9562 36.1586L20.0817 32.0323Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0344 28.2348L34.078 22.932C33.6616 22.374 33.5464 21.6468 33.7696 20.9868L35.8948 14.7216C36.4576 13.0608 34.8724 11.4744 33.2104 12.0372L26.9452 14.1624C26.7622 14.2246 26.5744 14.2593 26.3855 14.2703C26.3844 14.2703 26.3837 14.2692 26.3848 14.2692C26.08 14.286 25.7752 14.238 25.4908 14.1276C25.4884 14.1264 25.4848 14.1252 25.4824 14.124C25.4272 14.1024 25.372 14.0784 25.3192 14.0508C25.3168 14.0496 25.3132 14.0472 25.3108 14.046C25.2652 14.0232 25.2208 13.998 25.1764 13.9716C25.1632 13.9644 25.1512 13.956 25.138 13.9476C25.0948 13.9208 25.0528 13.8928 25.012 13.8615C25.0096 13.8597 25.007 13.8581 25.0046 13.8563C25.0024 13.8546 25.0001 13.8531 24.9979 13.8515L19.8748 10.0284L19.6984 9.89637C18.292 8.84757 16.294 9.86517 16.3168 11.6196L16.4008 18.2352C16.4092 18.9312 16.0756 19.5876 15.5068 19.9896L10.1044 23.8092C9.11918 24.5052 8.97758 25.77 9.52958 26.6616C9.78038 27.0672 10.174 27.3948 10.6984 27.558L17.0164 29.5224C17.3908 29.6388 17.7184 29.8548 17.9716 30.1392C18.1684 30.3612 18.3184 30.624 18.4096 30.9156L20.374 37.2336C20.4712 37.548 20.6284 37.8156 20.8264 38.0328C20.8344 38.0408 20.8422 38.0489 20.8499 38.0572C20.8758 38.0852 20.9012 38.1121 20.9284 38.1372C21.8056 38.976 23.332 38.946 24.1228 37.8264L27.9424 32.424C27.958 32.4012 27.9748 32.3808 27.9916 32.3592C28.0012 32.346 28.0108 32.3328 28.0216 32.3196C28.0312 32.3088 28.0408 32.298 28.0504 32.286C28.0696 32.2632 28.0876 32.2404 28.108 32.2188C28.1116 32.214 28.1164 32.2104 28.12 32.2068C28.294 32.0196 28.4992 31.866 28.7248 31.7532C29.0224 31.6044 29.356 31.5252 29.6992 31.5288L36.3148 31.6128C38.0644 31.6392 39.0832 29.6412 38.0344 28.2348Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8501 19.1808C20.6689 19.1808 20.4865 19.1112 20.3485 18.9732C20.0713 18.696 20.0713 18.246 20.3485 17.97L21.1753 17.1432C21.4525 16.866 21.9025 16.866 22.1785 17.1432C22.4557 17.4204 22.4557 17.8704 22.1785 18.1464L21.3517 18.9732C21.2137 19.1112 21.0313 19.1808 20.8501 19.1808Z",
  fill: "#2F2933"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4615 27.7922C29.2803 27.7922 29.0979 27.7226 28.9599 27.5846C28.6827 27.3074 28.6827 26.8574 28.9599 26.5802L29.7867 25.7534C30.0639 25.4762 30.5139 25.4762 30.7899 25.7534C31.0671 26.0306 31.0671 26.4806 30.7899 26.7578L29.9631 27.5846C29.8239 27.7226 29.6427 27.7922 29.4615 27.7922Z",
  fill: "#2F2933"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.1688 24.6026C25.4176 24.6026 24.6952 24.3062 24.1612 23.7722C23.5816 23.1926 23.2804 22.3886 23.3368 21.569C23.3632 21.1778 23.7028 20.8826 24.094 20.909C24.4852 20.9354 24.7804 21.275 24.754 21.6662C24.7252 22.0766 24.8764 22.4774 25.1656 22.7678C25.456 23.0582 25.8568 23.2082 26.2672 23.1794C26.6572 23.153 26.9968 23.4482 27.0244 23.8394C27.0508 24.2306 26.7556 24.569 26.3644 24.5966C26.2984 24.6002 26.2336 24.6026 26.1688 24.6026Z",
  fill: "#2F2933"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(30.7403 16.9835) scale(24)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F17FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.108,
  stopColor: "#7A14DA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2486,
  stopColor: "#6212B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3925,
  stopColor: "#4E0F8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5382,
  stopColor: "#3F0D73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6862,
  stopColor: "#340C60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8382,
  stopColor: "#2D0B55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B0B51"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -3,
  y1: 38.3998,
  x2: 22.1498,
  y2: 38.3998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0133,
  stopColor: "#844B25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2944,
  stopColor: "#BA6619"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6244,
  stopColor: "#844B25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9732,
  stopColor: "#542C09"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 26.4882,
  y1: 10.3199,
  x2: 22.3147,
  y2: 37.3381,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2405,
  stopColor: "#FFC635"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7148,
  stopColor: "#EBA52D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9963,
  stopColor: "#E39729"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.564dd8aa.svg";
export { ForwardRef as ReactComponent };